import script from "./ToastPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastPopup.vue?vue&type=script&setup=true&lang=js"

import "./ToastPopup.vue?vue&type=style&index=0&id=23dd3368&lang=scss"

const __exports__ = script;

export default __exports__